import React, { useEffect, useState } from 'react';
import GlobalTableGenerator from '../../../../../components/GlobalTableGenerator';
import { Autocomplete, Button, Paper, Stack, TextField } from '@mui/material';
import { useDispatch } from 'react-redux';
import { getIndividualMonthlyPerfomance } from '../../../../../redux/features/poinTrackerSlice';
import { useSelector } from 'react-redux';
import { getUsersUnderDepartment } from '../../../../../redux/features/assetManagementSlice';
import { ogdDepartmentId } from '../../../../../utils/constants/departmentDetails';
import GlobalAutoComplete from '../../../../../components/GlobalAutoComplete';

export default function IndividualMonthlyPerfomanceTable() {
  const [userId, setUserId] = useState(null);

  const dispatch = useDispatch();

  const individualMonthlyPerfomance = useSelector((state) => state.pointTracker.individualMonthlyPerfomance.data);
  const individualMonthlyPerfomanceLoading = useSelector(
    (state) => state.pointTracker.individualMonthlyPerfomance.loading,
  );

  const usersUnderDepartment = useSelector((state) => state.assetmanagement.usersUnderDepartment);
  const usersUnderDepartmentLoading = useSelector((state) => state.assetmanagement.loading);

  useEffect(() => {
    dispatch(getUsersUnderDepartment(ogdDepartmentId));
  }, []);

  useEffect(() => {
    const monthlyPerfomanceSignal = dispatch(getIndividualMonthlyPerfomance({ userId: userId?.userID || null }));

    return () => {
      monthlyPerfomanceSignal.abort();
    };
  }, [userId]);
  const columns = [
    { field: 'month', headerName: 'Month', width: 100, align: 'left', headerAlign: 'left' },
    { field: 'revenue', headerName: 'Revenue', width: 110, align: 'right', headerAlign: 'right' },
    { field: 'sales', headerName: 'Sales', width: 110, align: 'right', headerAlign: 'right' },
    { field: 'admissions', headerName: 'Admissions', width: 120, align: 'right', headerAlign: 'right' },
    { field: 'sfr', headerName: 'SFR', width: 100, align: 'right', headerAlign: 'right' },
    { field: 'tar', headerName: 'TAR', width: 100, align: 'right', headerAlign: 'right' },
    { field: 'arpu', headerName: 'ARPU', width: 110, align: 'right', headerAlign: 'right' },
    { field: 'incentive', headerName: 'Incentive', width: 110, align: 'right', headerAlign: 'right' },
    { field: 'assessments', headerName: 'Assessments', width: 130, align: 'right', headerAlign: 'right' },
    { field: 'acr', headerName: 'ACR', width: 100, align: 'right', headerAlign: 'right' },
  ];

  return (
    <Stack gap={2}>
      <Paper elevation={2} sx={{ p: 1, display: 'flex', justifyContent: 'space-between' }}>
        <GlobalAutoComplete
          data={usersUnderDepartment}
          loading={usersUnderDepartmentLoading}
          label="Name"
          keyName={{
            id: 'userID',
            value: 'name',
          }}
          sx={{ minWidth: 300 }}
          setSelectValue={setUserId}
          selectValue={userId}
        />
      </Paper>
      <GlobalTableGenerator
        rows={individualMonthlyPerfomance?.tableData || []}
        columns={columns}
        loading={individualMonthlyPerfomanceLoading}
      />
    </Stack>
  );
}
